<app-breadcrumbs></app-breadcrumbs>
<app-search-form [isDrugsComponent]="true" [searchedComponent]="'drugs'">
</app-search-form>
<app-drugs-template>
</app-drugs-template>
